<p>
  funding-options works!
</p>
